import {Delivery} from '@aboutyou/grpc-clients/tadarida/aysa_api/services/basket/v1/delivery.types';

export const useShouldCheckForPriceRise = (deliveries: Delivery[]) => {
  return deliveries.some(delivery =>
    delivery.items.some(item => item.appliedCouponPromotionId),
  );
};
